<template>
    <div class="admin__campaigns__context">
        <admin-campaigns-pop-up v-if="popup" :campaign="activeCampaign" @closePopup="hidePopup"></admin-campaigns-pop-up>
        <div class="content" v-if="!popup">
            <h1>Campaigns</h1>
            <div class="table__content">
                <div class="search__content">
                 <label>Show rows
                      <select class="input-filed perpage__value__section" name="perpage__field" v-model="perPage"  @change="changePerpage($event)">
                            <option value="10">10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </label>
                    <input type="text" @keyup.enter="search" class="search__value__section" placeholder="Search" v-model="searchParameter" :onchange="checkInput()" style="background: #FFFFFF; border: 2px solid #2EA3FF; box-sizing: border-box; border-radius: 5px; margin-right: 15px; height: 34px; width: 200px; padding-left: 15px; color: #9F9F9F; font-weight: 600; font-size: 14px;">
                    <button @click="search" class="btn__search">Search</button>
                </div>
                <div class="table__container">
                    <table style="width: 100%">
                        <tr>
                            <th style="width: 18%;">
                                <span style="padding-left: 15px;">
                                {{this.isMobile() ? 'ID': 'CAMPAIGN ID' }}
                                    <div @click="sort(0)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th>
                                <span>
                                 {{this.isMobile() ? 'NAME': ' CAMPAIGN NAME' }}
                                   
                                    <div @click="sort(1)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th style="width: 22%;">
                                <span>
                                    {{this.isMobile() ? 'ADVERTISER': ' ADVERTISER NAME' }}
                            
                                    <div @click="sort(6)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th style="width: 9%;">
                                <span>
                                    STARTED
                                    <div @click="sort(5)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>    
                                </span>
                            </th>
                            <th style="width: 9%;">
                                <span>
                                ENDED
                                    
                                    <div @click="sort(2)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th style="width: 16%;">
                                <span>
                                   BUDGET
                                    <div @click="sort(3)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th style="width: 7%;">
                                <span>
                                  STATUS
                                    <div @click="sort(4)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                        </tr>
                        <tr v-for="campaign in paginationCampaigns" v-bind:key="campaign.id" class="table__data" @click="campaignPopup(campaign)">
                            <td>{{campaign.id}}</td>
                            <td>{{campaign.name}}</td>
                            <td>{{campaign.advertiser}}</td>
                            <td>{{campaign.started}}</td>
                            <td>{{campaign.ended}}</td>
                            <td>{{campaign.budget}}</td>
                            <td class="status__value">
                                <div v-bind:class="[campaign.status !=='pending' ? campaign.status+'__status' : 'pending__status']" style="width: 16px; height: 16px; border-radius: 15px;"></div>
                            </td>
                        </tr>
                    </table>
                    <paginate
                        v-if="campaigns.length > 0"
                        v-model="campaignNumber"
                        :page-count="campaignTotal"
                        :container-class="'paginationContainer'"
                        :active-class="'paginationActive'"
                        :click-handler="campaignPaggination">
                    </paginate>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import toast from '@utils/toast.js'
import AdminCampaignsPopUp from './AdminCampaignsPopUp.vue'
import Search from '@utils/Search.js'
import { paginateList, paginationTotal } from '@utils/pagination.js'
export default {
    name: 'AdvertiserCampaigns',
    data: function () {
        return {
            campaigns: [],
            popup: false,
            campaignsSearch: [],
            searchParameter: '',
            startParameter: false,
            sorts: [false, false, false, false, false, false],
            activeCampaign: {},
            campaignNumber: 1,
            campaignTotal: 1,
            perPage: 10
        }
    },
    components: {
        AdminCampaignsPopUp
    },
    methods: {
        getCampaigns () {
            let data = {}
            this.request('/admin/list/campaigns', 'POST', data).then(response => {
                if (response.code === 0) {
                    toast.successMessage('Data is received')
                    this.campaigns = response.data
                    this.campaignsSearch = response.data
                    this.setTotalPagginationLength()
                } else {
                    toast.errorMessage(response.message)
                    if (response.code === 112) {
                        this.checkTokenConditions(this.getCampaigns)
                    }
                }
            }).catch(error => {
                toast.errorMessage(response.message)
            })
        },
        campaignPopup (campaign) {
            this.popup = true
            this.activeCampaign = campaign
        },
        hidePopup () {
            this.popup = false
        },
        checkInput () {
            if ( this.searchParameter === '' && this.startParameter) {
                this.campaigns = this.campaignsSearch
                this.setTotalPagginationLength()
            } else {
                if (this.searchParameter.length > 0) {
                    this.startParameter = true
                }
            }
        },
        search () { 
            if (this.searchParameter !== '') {
                var inputFileds = null
                var string = false
                var extra = null
                if (isNaN(this.searchParameter)) {
                    
                    inputFileds = [1, 6]
                    string = true
                    extra = [2, 3, 5]
                } else {
                    inputFileds = [0]
                    this.searchParameter = parseInt(this.searchParameter)
                    extra = [2, 3, 5]
                }
               
                var searchObject = new Search(inputFileds, this.campaignsSearch, this.searchParameter, Object.keys(this.campaignsSearch[0]), string, extra)
               
                searchObject.search().then((value) => {
                    if (value.length === 0) {
                        toast.simpleMessage('No result found from the search')
                    } else {
                        toast.successMessage('Search result received')
                    }
                    this.campaigns = value
                    this.setTotalPagginationLength()
                })
            }
        },
        sort (value) {
            this.sorts[value] = !this.sorts[value]
            if (this.sorts[value]) {
                toast.simpleMessage('Sort type: Ascending')
            } else {
                toast.simpleMessage('Sort type: Descending')
            }
            this.campaigns.sort((a, b) => {
                return b[Object.keys(b)[value]] < a[Object.keys(a)[value]] ? !this.sorts[value] ? -1 : 1
                : b[Object.keys(b)[value]] > a[Object.keys(a)[value]] ? this.sorts[value] ? -1 : 1 
                : 0
            })
        },
        campaignPaggination (number) {
            this.campaignNumber = number
        },
        changePerpage(event){
          if(event.target.value == this.campaigns.length){
              this.perPage = this.campaigns.length
          }else{
            this.perPage = event.target.value
          }
      
          this.setTotalPagginationLength()
        },
        setTotalPagginationLength () {
            // console.log("campagnes:"+this.campaigns)
            
            this.campaignTotal = paginationTotal(this.campaigns.length,this.perPage)
        },
      
        checkTokenConditions (callback) {
            try{
                var expiresDate = new Date(this.token.expires)
            } catch (err) {
                this.$router.push('/login')
            }
            var now = new Date()
            if (expiresDate <= now) {
                this.store.commit('setToken', {})
                this.$router.push('/login')
            } else {
                var body = {
                code: '',
                refresh_token: this.token.refresh_token
                }
                this.request('/refresh/token', 'POST', body).then((response) => {
                if (response.code === 0 ) {
                    store.commit('setToken', response.data[0])
                    store.commit('setDriver', response.data[0].driver)
                    callback()
                } else if (response.code === 112) {
                    this.store.commit('setToken', {})
                    this.$router.push('/login')
                }
                }).catch((error) => {
                })
            }
            var token = this.token
            token.redirect = false
            this.store.commit('setToken', token)
        }
    },
    created: function () {
        this.getCampaigns()
    },
    computed: {
      paginationCampaigns: function () {
         // console.log(this.campaigns)
        return paginateList(this.campaigns, this.campaignNumber, this.perPage)
      }
    },
    watch:{
     perPage:function(){
          if(this.perPage == this.campaigns.length){
            this.campaignNumber =1;
          }
      }
    }
}
</script>
<style scoped>
.admin__campaigns__context{
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: hidden;
    text-align: left;
    box-sizing: border-box;
    position: relative;
}
th {
    width: 18%;
    border-collapse: collapse;
}
th span {
    display: flex;
    white-space: nowrap;
}
th div {
    display: inline-block; 
    margin-left: 5px;
    position: relative;
}
.table__data {
    height: 50px;
}
table{
    border-collapse: separate;
    border-spacing: 0 8px;
    border-style: hidden;
}
td{
    cursor: pointer;
}
table { 
    border-collapse: separate !important; 
}
td { 
    border: solid 1px transparent; 
    background: rgba(235, 234, 244, 0.25);
}
table tr td:first-child {
    border-top-left-radius: 15px;
    border-left-width:15px;
    border-bottom-left-radius: 15px;
}
table tr td:last-child {
    border-top-right-radius: 15px;
    border-right-width:15px;
    border-bottom-right-radius: 15px;
}
.content {
    text-align: left;
    padding: 20px;
}
.content h1 {
    margin-top: 59px;
}
.table__content {
    margin-top: 58px;
}
.header__section{
    display: block;
    margin-right: 45px;
}
.sort__up {
    position: absolute;
}
.header__name{
    display: inline-block;
}
.header__style{
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height */
    color: #1F1F1F;
}
.header__sort{
    display: inline-block;
    position: relative;
    margin-left: 10px;
    top: 2px;
}
.admin__list{
    max-height: 49vh;
    overflow: auto;
}
.table__element{
    display: flex;
    padding: 0px 0px 5px 15px;
    background: rgb(235, 234, 244) none repeat scroll 0% 0%;
    opacity: 0.48;
    border-radius: 0.5em;
}
.search__content{
    text-align: right;
    margin-bottom: 25px;
}
.status__value {
    padding-left: 32px;
}
.search__value__section, .perpage__value__section {
    background: #FFFFFF;
    border: 2px solid #2EA3FF;
    box-sizing: border-box;
    border-radius: 5px;
    margin-right: 15px;
    height: 34px;
    width: 200px;
    padding-left: 15px;
    color: #9F9F9F;
    font-weight: 600;
    font-size: 14px;
}
.btn__search {
    background: #2EA3FF;
    border: 2px solid #2EA3FF;
    border-radius: 5px;
    color: #fff;
    height: 34px;
    width: 86px;
    font-weight: 600;
    font-size: 13px;
}
.sort__image{
    widows: 17px;
    height: 7px;
    margin: 0 5px;
    cursor: pointer;
}
.search__content label{
    float:left;
}
@media only screen and (max-width: 1550px)  {
    .status__value {
        padding-left: 26px;
    }
}
@media only screen and (max-width: 1350px)  {
    .status__value {
        padding-left: 22px;
    }
}
@media only screen and (max-width: 1200px){
  .content h1 {
    margin-top: 20px;
     margin-bottom: 20px;
    }
    .search__content label{
        margin: 15px 0;
    }
    .table__container{
        overflow-x: auto;
        width: 100%;
    }
}
@media only screen and (max-width: 1150px)  {
    .status__value {
        padding-left: 18px;
    }
}
@media only screen and (max-width: 950px) {
    th {
        font-size: 15px;
        padding-right: 5px;
    }
    .sort__image {
        height: 6px;
        top: 1px;
    }
}
@media only screen and (max-width: 900px) {
    .search__content {
        text-align: left;
    }
}
@media only screen and (max-width: 850px) {
    td {
        font-size: 14px;
    }
    .paginationContainer {
        float: left;
        padding-left: 0px;
    }
    .sort__image {
        height: 5px;
        top: 3px;
    }
} 
@media only screen and (min-width: 600px) and (max-width: 1024px) {
    
     .search__content label{
         margin:0 !important;
     }
     .btn__search{
        margin-right: 15px;
        margin-top: 10px;
        float:right;
     }
     .table__container{
         margin-top: 80px;
     }
     .search__content input{
         margin-left: 13px;
     }
}
</style>
